import { gql, GraphQLClient } from 'graphql-request'
import { RECETAS_FIELDS_FRAGMENT } from '../interfaces/fragments'
import { PageInfoProps, PageInputProps } from '../../../interfaces'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { AccessToken } from '../../../base/models/paramsModel'
import { RecetaProp } from '../interfaces'

const query = gql`
  ${RECETAS_FIELDS_FRAGMENT}
  query LISTADO($limit: Int!, $reverse: Boolean, $page: Int!, $query: String) {
    recetaListado(limit: $limit, reverse: $reverse, page: $page, query: $query) {
      docs {
        ...RecetaFieldsFragment
      }
      pageInfo {
        hasNextPage
        hasPrevPage
        totalDocs
        limit
        page
        totalPages
      }
    }
  }
`
interface apiRecetasResponse {
  docs: RecetaProp[]
  pageInfo: PageInfoProps
}
export const apiRecetasListado = async (
  pageInfo: PageInputProps,
): Promise<apiRecetasResponse> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)
    const data: any = await client.request(query, { ...pageInfo })
    return data.recetaListado
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
